import image1 from '@/assets/image_2.png';
import login2 from '@/assets/login_2.svg';
import logo from '@/assets/logo.svg';
import yaraUmbrellaLogo from '@/assets/yara_umbrella.svg';
import { Button, Select, Headline, Paragraph, Label, Caption, Subtitle, Title } from '@yaradigitallabs/ahua-react';
import { OptimizedImage } from '../ui/OptimizedImage';

type LoginProps = {
    singleSignOnClick: (event: React.MouseEvent) => void;
    singleSignOn: boolean;
}

export const Login = ({singleSignOnClick, singleSignOn}: LoginProps) => {
    return (
        <div className="w-full h-screen flex">
            <div className="w-[38%] h-screen flex flex-col justify-between">
                <div className='flex flex-row justify-between items-center p-12'>
                    <div className='flex flex-row gap-3'>
                        {/* <img src={yaraUmbrellaLogo} alt="Yara Umbrella Logo" /> */}
                        <Headline><span className='text-[28px] font-max-bold text-[#102D6A] font-medium'>DPP</span><span className='text-[28px] font-max-bold text-[#0066CC] font-medium'> Vision Portal</span></Headline>
                    </div>
                    <Select cover="fill" value="ENG" css={{width: '180px'}} className="font-noto-sans" size="xs" items={[{value: 'ENG', text:'English'}]}/>
                </div>
                <div className='py-16 px-12'>
                    <img src={login2} alt="Login illustration" />
                    <div className='mt-16'>
                        <Title css={{color: '#102D6A'}} className='text-[#102D6A] font-bold font-max-bold text-[24px]' size="xl">The go-to platform for Yara production</Title>
                        <Subtitle css={{color: '#00205C'}} className='mt-3' size='s'>Get access to advanced tools and valuable data that will accelerate Operational Excellence across Yara’s production sites.</Subtitle>
                        <div className='flex flex-row flex-wrap gap-3 mt-6 mb-8'>
                            {['dws', 'mea', 'not', 'aoi', 'tmn', 'mt', 'psb', 'stm', 'dt', 'sc'].map((item) => (
                                <div key={item} className='flex justify-center leading-4 w-[44px] bg-[#00205B] text-white font-bold text-sm font-noto-sans px-1.5 py-3 border rounded-xl'>
                                    {item}
                                    
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='mt-16'>
                        <Button css={{width: '100%'}} className='font-noto-sans' size='n' onClick={(event) => singleSignOnClick(event)}>Log in with SSO</Button>
                    </div>
                </div>
                <div className='p-12 flex flex-row justify-between items-center'>
                    <div>
                        <img src={logo} alt="Yara Logo" />
                        <Label className='mt-2 text-xs' size='xs'>Knowledge grows</Label>
                    </div>
                    <Button variant="ghost" size="n" iconLeading={"Privacy"} >Privacy Notice</Button>

                </div>
            </div>
            <div className="w-[62%] h-full flex justify-center items-center">
                <OptimizedImage
                  src={image1}
                  alt="Login illustration"
                  className="w-full h-full"
                  placeholder="bg-gradient-to-br from-blue-50 to-indigo-100"
                  priority={true}
                />
            </div>
        </div>
    );
}